import { render, staticRenderFns } from "./StationDetails.vue?vue&type=template&id=85e12ed2&"
import script from "./StationDetails.vue?vue&type=script&lang=js&"
export * from "./StationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports